import React, { useRef, useState, useEffect } from 'react';
import { BusyStateIndicator } from '@sas/nova-commons/components/BusyStateIndicator';
import { Pane } from './Pane';
import { useLoadingText } from '../locale/I18nContext';
import { getReportImageManager } from './ReportImageManager';
import { ThemeProvider } from '@sas/nova-commons/theme';
import { useLoadingBusyTokens, useLoadingThemeContext, } from './ReportContainer/ReportThemeContainer';
import { useResizeObserverRef } from '@sas/nova-commons/hooks/useResizeObserver';
import { exposeTestId } from '../config';
export const ReportImage = function (props) {
    const [imageSize, setImageSize] = useState(null);
    const [imageLoadComplete, setImageLoadComplete] = useState(false);
    const [imageSource, setImageSource] = useState('');
    const [hasClicked, setHasClicked] = useState(false);
    const imgRef = useRef(null);
    const loadingText = useLoadingText();
    const [loadingTheme, style] = useLoadingThemeContext();
    const [busyAnimationTokens, busyTokens] = useLoadingBusyTokens();
    useEffect(() => {
        var _a, _b;
        const onError = props.onError;
        const manager = getReportImageManager(props.host, props.authenticationType);
        const sub = props.objectName
            ? (_a = manager.getObjectImage(props.reportUri, props.objectName, imageSize)) === null || _a === void 0 ? void 0 : _a.subscribe((el) => {
                if (el.imageURL) {
                    setImageSource(el.imageURL);
                }
                else {
                    onError === null || onError === void 0 ? void 0 : onError(el.error);
                }
            })
            : (_b = manager.getReportImage(props.reportUri, imageSize, props.sectionIndex)) === null || _b === void 0 ? void 0 : _b.subscribe((el) => {
                if (el.imageURL) {
                    setImageSource(el.imageURL);
                }
                else {
                    onError === null || onError === void 0 ? void 0 : onError(el.error);
                }
            });
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
    }, [
        props.host,
        props.authenticationType,
        props.reportUri,
        props.objectName,
        props.sectionIndex,
        props.onError,
        imageSize,
    ]);
    const [surfaceRef] = useResizeObserverRef(({ contentRect }) => {
        if (contentRect && !imageSize) {
            const width = contentRect.width;
            const height = contentRect.height;
            if (width > 0 && height > 0) {
                setImageSize({ width, height });
            }
        }
    });
    const onImgLoad = () => {
        if (!imageLoadComplete && imgRef.current && imageSize) {
            setImageLoadComplete(true);
        }
    };
    return (React.createElement(ThemeProvider, { currentTheme: loadingTheme },
        React.createElement(Pane, { ref: surfaceRef, style: {
                position: 'relative',
                display: 'flex',
                flexShrink: 1,
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
                fontFamily: style === null || style === void 0 ? void 0 : style.fontFamily,
            } },
            React.createElement("img", { ref: imgRef, src: imageSource, style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    visibility: imageLoadComplete ? 'visible' : 'hidden',
                }, onLoad: onImgLoad, onMouseDown: () => setHasClicked(!props.mobileView && imageLoadComplete), "data-testid": exposeTestId() ? props.objectName + '-image' : undefined }),
            React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    backgroundColor: '#FFFFFFA0',
                    visibility: imageLoadComplete && hasClicked ? 'visible' : 'hidden',
                } }),
            React.createElement(BusyStateIndicator, { style: { zIndex: 1 }, active: hasClicked || !imageLoadComplete, text: loadingText, animationTokens: busyAnimationTokens, tokens: busyTokens, delay: 0 }))));
};
